import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (this.auth.isAuthenticated()) {
      // Auto-load profile in the background on refresh / direct navigation
      if (!this.auth.currentUserProfile()) {
        this.auth.getProfile().subscribe({
          error: (err) => {
            console.warn('Could not load profile in AuthGuard:', err);
            this.auth.clear();
            this.router.navigate(['/login']);
          }
        });
      }
      return true;
    }

    // Redirige al login si no está autenticado
    return this.router.createUrlTree(['/login']);
  }
}
